import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";

@Component({
    standalone: true,
    selector: "s25-ng-select",
    template: `
        <select
            class="cn-form__control"
            [(ngModel)]="selected"
            (ngModelChange)="selectedChange.emit($event)"
            [attr.aria-label]="ariaLabel"
        >
            @for (option of options; track option.value) {
                <option [ngValue]="option.value">{{ option.label }}</option>
            }
        </select>
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule],
})
export class S25SelectComponent<T> {
    @Input({ required: false }) selected?: T;
    @Output() selectedChange = new EventEmitter<T>();
    @Input({ required: true }) options: { value: T; label: string }[] = [];
    @Input({ required: false }) ariaLabel: string;
}
